import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, } from "@mui/material";
import DOMPurify from "dompurify";
import { useTranslation } from "react-i18next";
import { CloseButton } from "./CloseButton";
import "./GenericPromptDialog.scss";
import DoraButton from "./DoraButton";
const GenericPromptDialog = ({ title, text, children, cancelText, continueText, continueButtonColor, onCloseClick, onCancelClick, onContinueClick, focusOnContinueButton, buttonsDisabled, }) => {
    const { t } = useTranslation("components");
    const con = continueText || t("buttonLabels.continue");
    const cancel = cancelText || t("buttonLabels.cancel");
    let continueButtonVariant = "primary";
    switch (continueButtonColor) {
        case "primary":
            continueButtonVariant = "primary-filled";
            break;
        case "error":
            continueButtonVariant = "error";
            break;
    }
    return (_jsx(Dialog, { open: true, onClose: onCloseClick || onCancelClick, fullWidth: true, maxWidth: "xs", children: _jsxs("form", { onSubmit: (e) => {
                e.preventDefault();
                onContinueClick();
            }, children: [_jsx(DialogTitle, { children: _jsxs("div", { className: "generic-prompt-dialog__title", children: [_jsx("div", { children: title }), _jsx(CloseButton, { className: "generic-prompt-dialog__close-button", onClick: onCloseClick || onCancelClick })] }) }), (text || children) && (_jsxs(DialogContent, { children: [text && (_jsx("div", { dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(text) } })), children] })), _jsx(DialogActions, { children: _jsxs(Stack, { spacing: 1, direction: "row", children: [_jsx(DoraButton, { type: "button", onClick: onCancelClick, variant: "ghost", disabled: buttonsDisabled, children: cancel }), _jsx(DoraButton, { type: "submit", autoFocus: focusOnContinueButton, variant: continueButtonVariant, color: continueButtonColor || undefined, disabled: buttonsDisabled, children: con })] }) })] }) }));
};
export default GenericPromptDialog;
//# sourceMappingURL=GenericPromptDialog.js.map